<template>
  <div class="home">
    <!-- <h1 class="subtitle-1 grey--text">Obras</h1> -->

    <div v-if="loading">
      <img src="img/logo_cargando.gif" alt="apa" />
      <h1 class="title">Cargando . . .</h1>
    </div>
    <v-container class="my-5 " v-if="!loading">
      <v-card class="pa-3" flat>
        <v-card-text>
          <v-layout row v-for="sol in solicitudes" :key="sol.id">

            <v-flex class="xs12 sm4 md4">
              <div class="caption grey--text">Obra</div>
              <div>{{ sol.obraNombreOriginal }}</div>
            </v-flex>

            <v-flex class="xs6 sm4  md4">
              <div class="caption grey--text">Nro. Solicitud</div>
              <div>{{ sol.id }}</div>
            </v-flex>


            <v-flex class="xs6 sm4 md4">
              <div class="caption grey--text">Estado</div>
              <div>{{ sol.estado }}</div>
            </v-flex>

            <v-flex class="xs12 sm12 md12 lg12 xl12">
              <v-divider></v-divider>
            </v-flex>
            
            <!-- <v-flex class="xs12 sm6">
              <div class="caption grey--text">Participación</div>
              <div
                class="caption"
                v-for="temaAutor in obra.temasAutores"
                :key="temaAutor.autor.id"
              >
                {{ temaAutor.autor.nombres + " " + temaAutor.autor.apellidos }}
                {{ temaAutor.participacion }}%
              </div>
            </v-flex> -->
          </v-layout>
        </v-card-text>
        <v-card-actions></v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      solicitudes: [],
      loading: false,
      showDialog: true
    };
  },
  mounted() {
    this.loading = true;
    axios
      .get("/miapa/solicitudregistroobra")
      .then(response => {
        this.loading = false;
        this.solicitudes = response.data;
        console.log(response);
      })
      .catch(error => {
        this.loading = false;
        console.log(error);
      });
  }
};
</script>

<style scoped>
.project.registrado {
  border-left: 4px solid #2196f3;
}
.project.procesando {
  border-left: 4px solid #455a64;
}
.project.retrasado {
  border-left: 4px solid #b71c1c;
}

.v-chip.registrado {
  background: #2196f3;
}
.v-chip.procesando {
  background: #455a64;
}
.v-chip.retrasado {
  background: #b71c1c;
}
</style>
